import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SignupState {
  lastSignup: {
    email: string;
    timestamp: string;
  } | null;
}

const initialState: SignupState = {
  lastSignup: null,
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    addEmail: (state, action: PayloadAction<string>) => {
      state.lastSignup = {
        email: action.payload,
        timestamp: new Date().toISOString(),
      };
    },
    clearSignup: (state) => {
      state.lastSignup = null;
    },
  },
});

export const { addEmail, clearSignup } = signupSlice.actions;
export default signupSlice.reducer; 